import { Stack, Tabs, Text } from '@common/ui'
import { com } from '@eidu/web'
import EntityFormDisplay from '../../../../components/data/EntityFormDisplay'
import DraftFieldValue from '../../../../domain/entity/DraftFieldValue'
import Field = com.eidu.entity.field.Field
import FieldId = com.eidu.entity.field.FieldId
import FieldType = com.eidu.entity.field.FieldType
import EntityType = com.eidu.entity.type.EntityType
import EntityId = com.eidu.entity.EntityId

type EntityFieldDisplayGroupProps = {
  entityType: EntityType
  fields: ReadonlyMap<FieldId, DraftFieldValue>
  entityId?: EntityId
}

const EntityFieldDisplayGroup = ({ entityType, fields, entityId }: EntityFieldDisplayGroupProps) => {
  const titleFieldIds = entityType.label.primary.argumentFields.asJsReadonlyArrayView()
  const isTitleField = (field: Field) => titleFieldIds.some((id) => id.equals(field.id))

  const allFields = entityType.fields.asJsReadonlyArrayView().filter((field) => !isTitleField(field))
  const referenceSetFields = allFields.filter((field) => field.type === FieldType.ReferenceSet)
  const otherFields = allFields.filter((field) => field.type !== FieldType.ReferenceSet)

  return (
    <Stack gap="lg">
      {otherFields.length > 0 && (
        <div style={{ borderTop: '1px solid #eee' }}>
          {otherFields.map((field) => (
            <EntityFormDisplay
              key={`entity-form-field-${field.id.toString()}`}
              field={field}
              fieldValue={fields.get(field.id)}
              entityId={entityId}
            />
          ))}
        </div>
      )}

      {referenceSetFields.length > 0 && (
        <Tabs
          key={referenceSetFields.map((field) => field.id.toString()).join('|')}
          defaultValue={referenceSetFields[0].id.toString()}
        >
          <Tabs.List>
            {referenceSetFields.map((field) => (
              <Tabs.Tab key={field.id.toString()} value={field.id.toString()}>
                <Text fw={600} size="sm">
                  {field.name}
                </Text>
              </Tabs.Tab>
            ))}
          </Tabs.List>

          {referenceSetFields.map((field) => (
            <Tabs.Panel key={field.id.toString()} value={field.id.toString()} pt="md">
              <EntityFormDisplay field={field} fieldValue={fields.get(field.id)} entityId={entityId} />
            </Tabs.Panel>
          ))}
        </Tabs>
      )}
    </Stack>
  )
}

export default EntityFieldDisplayGroup
